import React, { lazy } from 'react';
import { Routes, Route } from 'react-router-dom';

const SellPairs = lazy(() => import('../../pages/SellPairs/SellPairsPage'));

function PagesRoute() {
  return (
    <Routes>
      <Route path="/*" element={<SellPairs />} />
    </Routes>
  );
}

export default PagesRoute;
